export const CHECKSUM_ERROR = (state, value) => {
  state.checksumError = value
}
